import {
  Button,
  Card,
  Link,
  MultiToggle,
  Table,
  Title,
  Toggle
} from 'components'
import { PageLayout as Layout } from 'pages'
import { useGetQuery, usePostQuery } from 'hooks'
import { apiFetch } from 'actions/apiFetch'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

export const TriviaAdmin = ({}) => {
  const { id } = useParams()

  const { data, error, isFetching, reFetch } = useGetQuery({
    url: `/host/queue/${id}`
  })

  const changeState = ({ target: { name, value } }) => {
    if (!data?.queue?.QueueItems || data?.queue?.QueueItems.length < 1) return
    apiFetch({ method: 'POST', path: `/queues/${data?.queue?.id}`, payload: { id: data?.queue?.id, state: value[1] } })
      .then(() => reFetch(true))
  }

  const addQuestions = () => {
    apiFetch({ method: 'PUT', path: '/trivia', payload: { id: data?.queue?.id, count: 10 } })
    reFetch(true)
  }

  return (
    <Layout>
      <Card margin="1rem">
        <Title level={2}>{data?.queue?.type}</Title>
        <MultiToggle
          data={[
            ['Pending', 'pending', 'warning'],
            ['Active', 'active', 'success'],
            ['Completed', 'completed'],
            ['Delete', 'deleted', 'chrome']
          ]}
          step={data?.queue?.state}
          name="state"
          onChange={changeState}
        />
        <Link to={`/games/trivia/${id}`}>Go to game</Link>
        {data?.queue?.QueueItems?.length === 0
          ? (
          <Button onPress={addQuestions}>Add trivia questions</Button>
            )
          : (
          <Table
            data={data?.queue?.QueueItems || []}
            columns={[
              {
                title: 'Type',
                key: 'details',
                render: ({ type }) => <>{type}</>
              },
              {
                title: 'Questions',
                key: 'details',
                render: ({ question }) => (
                  <span dangerouslySetInnerHTML={{ __html: question }}></span>
                )
              }
            ]}
          />
            )}
      </Card>
    </Layout>
  )
}
